// @flow
import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import DealerModel from 'Stores/DealerModel';
import { leadTracking } from 'Utils/trackingAttributes';
import { MODAL_TYPES } from 'Containers/ContactForm/contactFormConstants';

const cx = classNames.bind({ ...styles });

type Props = {
  dealer: DealerModel,
  handleFlyout: () => void,
  onOpenContact: () => void,
  onOpenConfigurator: () => void,
};

export default class Lead extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      itemIsHovered: false,
    };
  }

  render() {
    const { dealer, onOpenContact, onOpenConfigurator, handleFlyout, forceMobileMenu } = this.props;
    const { itemIsHovered } = this.state;
    const dfmm = { 'data-force-mobile-menu': forceMobileMenu };

    const ariaLabelOpensNewTab = ' – öffnet auf der gleichen Seite';
    const ariaLabelOpensNewTabOrRightClick =
      ' – öffnet per Klick auf der gleichen Seite oder kann über das Browserkontextmenü in einem neuen Fenster oder Tab geöffnet werden';

    const itemText = {
      requestForConsultation:
        dealer.settings.isOsbUser || dealer.isSalesPartnerOnly()
          ? 'Individuelle Beratung'
          : 'Terminanfrage',
      onlineServiceBooking: dealer.settings.isOsbUser ? 'Werkstatttermin' : 'Terminanfrage',
      probefahrt: 'Probefahrt',
      angebotsanfrage: 'Angebotsanfrage',
      konfigurator: 'Konfigurator',
      gebrauchtwagenbewertung: 'Gebrauchtwagenbewertung',
    };

    const mouseEvents = {
      onMouseEnter: () =>
        this.setState({
          itemIsHovered: true,
        }),
      onMouseLeave: () =>
        this.setState({
          itemIsHovered: false,
        }),
    };

    return (
      <ul className={cx('lead-nav', itemIsHovered && styles.leadNavHover)} {...dfmm}>
        {dealer.isServicePartnerOnly() && !dealer.settings.isOsbUser ? null : (
          <li className={cx('lead-nav__item')} {...dfmm}>
            <button
              className={cx('buttonHint')}
              aria-label={`${itemText.requestForConsultation}${ariaLabelOpensNewTab}`}
              onClick={(evt) => {
                evt.preventDefault();

                handleFlyout({ id: -666 });
                this.props.updateMultipleUrlQuery({
                  modaltype: MODAL_TYPES.REQUEST_FOR_CONSULTATION_FK.name,
                  showmodal: 'true',
                });
              }}
              {...mouseEvents}
              {...leadTracking((items) => items.Beratungstermin)}
            >
              {itemText.requestForConsultation}
            </button>
          </li>
        )}

        {!dealer.isSalesPartnerOnly() &&
          !(
            !dealer.settings.isOsbUser &&
            dealer.settings.isSalesPartner &&
            dealer.settings.isServicePartner
          ) && (
            <li className={cx('lead-nav__item')} {...dfmm}>
              <Link
                to="/werkstatttermin/"
                aria-label={`${itemText.onlineServiceBooking}${ariaLabelOpensNewTabOrRightClick}`}
                onClick={(evt) => {
                  evt.preventDefault();

                  handleFlyout({ id: -666 });
                  this.props.updateMultipleUrlQuery({
                    modaltype: MODAL_TYPES.ONLINE_SERVICE_BOOKING.name,
                    showmodal: 'true',
                  });
                }}
                {...mouseEvents}
                {...leadTracking((items) => items.Werkstatttermin)}
              >
                {itemText.onlineServiceBooking}
              </Link>
            </li>
          )}
        {dealer.settings.isSalesPartner && (
          <Fragment>
            <li className={cx('lead-nav__item')} {...dfmm}>
              <Link
                to="/probefahrt/"
                aria-label={`${itemText.probefahrt}${ariaLabelOpensNewTabOrRightClick}`}
                onClick={(evt) => {
                  evt.preventDefault();

                  handleFlyout({ id: -666 });
                  onOpenContact(2);
                }}
                {...mouseEvents}
                {...leadTracking((items) => items.Probefahrt)}
              >
                {itemText.probefahrt}
              </Link>
            </li>
            <li className={cx('lead-nav__item')} {...dfmm}>
              <Link
                to="/angebotsanfrage/"
                aria-label={`${itemText.angebotsanfrage}${ariaLabelOpensNewTabOrRightClick}`}
                onClick={(evt) => {
                  evt.preventDefault();

                  handleFlyout({ id: -666 });
                  onOpenContact(0);
                }}
                {...mouseEvents}
                {...leadTracking((items) => items.Angebotsanfrage)}
              >
                {itemText.angebotsanfrage}
              </Link>
            </li>
            {dealer.settings.showCarConfigurator ? (
              <li className={cx('lead-nav__item')} {...dfmm}>
                <Link
                  to="?modaltype=CAR_CONFIGURATOR&showmodal=true"
                  aria-label={`${itemText.konfigurator}${ariaLabelOpensNewTabOrRightClick}`}
                  onClick={() => {
                    handleFlyout({ id: -666 });

                    if (onOpenConfigurator) {
                      onOpenConfigurator();
                    }
                  }}
                  {...mouseEvents}
                  {...leadTracking((items) => items.Konfigurator)}
                >
                  {itemText.konfigurator}
                </Link>
              </li>
            ) : null}
          </Fragment>
        )}
        {dealer.settings.showUsedcarValuation && (
          <Fragment>
            <li className={cx('lead-nav__item')} {...dfmm}>
              <Link
                to="?modaltype=USED_CAR_EVALUATION&showmodal=true"
                aria-label={`${itemText.gebrauchtwagenbewertung}${ariaLabelOpensNewTabOrRightClick}`}
                {...mouseEvents}
                {...leadTracking((items) => items.Gebrauchtwagenbewertung)}
              >
                {itemText.gebrauchtwagenbewertung}
              </Link>
            </li>
          </Fragment>
        )}
      </ul>
    );
  }
}

Lead.Admin = class extends Component {
  render() {
    const dfmm = { 'data-force-mobile-menu': this.props.forceMobileMenu };
    return <ul className={cx('lead-nav')} {...dfmm} />;
  }
};
